import { Link } from "react-router-dom";
import { Star, Play } from "lucide-react";
import { Movie } from "@/data/movies";

interface MovieCardProps {
  movie: Movie;
}

export function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link to={`/movie/${movie.id}`}>
      <div className="group relative overflow-hidden rounded-lg bg-background/50 backdrop-blur cursor-pointer h-72 flex flex-col">
        <div className="relative overflow-hidden h-full">
          <img
            src={movie.poster}
            alt={movie.title}
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4">
            <div className="flex items-center gap-2 mb-2">
              <Play className="w-4 h-4 fill-white" />
              <span className="text-sm font-medium text-white">Play</span>
            </div>
            <h3 className="font-bold text-white line-clamp-2 text-sm">{movie.title}</h3>
            <div className="flex items-center gap-1 mt-2">
              <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
              <span className="text-xs text-white/90">{movie.rating}</span>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}
